
export default {
  name: 'MediaPopup',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    mediaUrl: { type: String, default: '' },
    altText: { type: String, default: 'Media' },
    fallbackMessage: { type: String, default: 'Medie ikke tilgængelig' },
    showTitle: { type: Boolean, default: true }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    },
    isPdf() {
      if (!this.mediaUrl) {
        return false;
      }
      const url = this.mediaUrl.toLowerCase();
      return url.includes('.pdf') || url.includes('application/pdf');
    },
    pdfUrl() {
      if (!this.isPdf || !this.mediaUrl) {
        return '';
      }
      // Normalize URL (add https: if starting with //)
      const normalizedUrl = this.mediaUrl.startsWith('//')
        ? `https:${this.mediaUrl}`
        : this.mediaUrl;
      // Format PDF URL for iframe viewer
      return `${normalizedUrl}#toolbar=1&navpanes=1&scrollbar=1`;
    },
    dialogMaxWidth() {
      return this.isPdf ? '90vw' : 'none';
    },
    dialogMaxHeight() {
      return this.isPdf ? '90vh' : 'none';
    },
    dialogWidth() {
      return this.isPdf ? '90vw' : 'auto';
    },
    normalizedMediaUrl() {
      if (!this.mediaUrl) {
        return '';
      }
      // Handle Contentful URLs that start with // - add https:
      if (this.mediaUrl.startsWith('//')) {
        return `https:${this.mediaUrl}`;
      }
      return this.mediaUrl;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleDialogChange(value) {
      if (!value) {
        this.close();
      }
    },
    onImageLoad(_event) {
      // Force dialog to resize to content
      this.$nextTick(() => {
        const dialog = this.$el.closest('.v-dialog');
        if (dialog) {
          dialog.style.width = 'auto';
          dialog.style.height = 'auto';
        }
      });
    }
  }
}
